import { render } from "./coaches.vue?vue&type=template&id=36205f25"
import script from "./coaches.vue?vue&type=script&lang=js"
export * from "./coaches.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__